import React, {Component} from 'react';
import ErrorPage from './ErrorPage';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

class PageContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service.
    console.error('ReactJS Error Boundaries: ' + errorInfo.componentStack);
    console.error('ReactJS Error Boundaries: ' + error.toString());
    this.setState({hasError: true});
  }

  render() {
    return (
      <div className={this.props?.class && this.props.class}>
        {(
          () => {
            if (this.props.errorHandler.error || this.state.hasError) {
              if (this.props.errorHandler.error >= 400
                && this.props.errorHandler.error < 408 ) {
                return <ErrorPage type="notFound"/>;
              }
              else {
                return <ErrorPage type="serverError"/>;
              }
            }
            else {
              return this.props.children;
            }
          }
        )()}
      </div>
    );
  }
}

PageContainer.propTypes = {
  class: PropTypes.string,
  errorHandler: PropTypes.object,
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({errorHandler: state.errorHandler});
const mapDispatchToProps = { };
export default connect(mapStateToProps, mapDispatchToProps)(PageContainer);
